export const sharingUnitTariffRecipientFilter = {
  key: 'recipient-filter',
  query: 'recipients',
  isAvailable: () => true,
  aggregationKey: 'source_organizations',
};
